import { IAppState } from "state";
import { IOrganisation } from "models/IOrganisation";

export const org = (state: IOrganisation | null = null) => state;

export const getOrg = (state: IAppState) => state.org;
